import { queries as scheduleInterviewsQueries } from "domains/hire/containers/ScheduleInterviews/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: {
  jobId: string;
  locationId: number;
  applicantIds: Array<string>;
}): Array<WarmableQuery> => scheduleInterviewsQueries(input);
